import { PrinterIcon, MapIcon, SparklesIcon, LifeBuoyIcon, AwardIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface Bonus {
  icon: LucideIcon
  title: string
  description: string
  price: string
}

export const bonuses: Bonus[] = [
  {
    icon: PrinterIcon,
    title: 'Schede Operative Stampabili',
    description: 'Modelli riutilizzabili e percorsi pronti da stampare per ogni unità del programma di Geografia.',
    price: '19 €',
  },
  {
    icon: MapIcon,
    title: 'Atlante Illustrato: Le Schede dei Paesi del Mondo',
    description: 'Una scheda sintetica per ogni Paese: territorio, clima, popolazione ed economia in un colpo d’occhio.',
    price: '19 €',
  },
  {
    icon: SparklesIcon,
    title: 'Geografia Senza Materiali: 40 Attività',
    description: 'Quaranta proposte da svolgere senza mappe stampate, LIM o materiale aggiuntivo.',
    price: '27 €',
  },
  {
    icon: LifeBuoyIcon,
    title: 'Il Kit di Sopravvivenza per il Docente di Geografia',
    description: 'Risposte pronte, definizioni e spiegazioni guidate per chi non è specialista della materia.',
    price: '36 €',
  },
  {
    icon: AwardIcon,
    title: 'Passaporto del Geografo + Diploma di Percorso Completo',
    description: 'Il quaderno di viaggio dell’alunno e l’attestato finale per gli 8 volumi del percorso.',
    price: '27 €',
  },
]

export const BONUS_TOTAL = '128 €'
